/**
 * Created by Bart Decorte
 * Date: 2019-10-06
 * Time: 14:50
 */
import Page from '../Page';

export default class AppsToken extends Page {
  //
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Apps/AppsToken.js